var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!this.$store.state.loader)?_c('div',{staticClass:"mainDiv",class:this.$store.state.restaurantInfo.skin},[_c('v-container',[_c('main-menu'),_c('categories-menu'),_c('items-menu')],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }